import { render, staticRenderFns } from "./vertical-table-row.vue?vue&type=template&id=0502182e"
import script from "./vertical-table-row.vue?vue&type=script&lang=js"
export * from "./vertical-table-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports